<ng-template #modal>
  <div class="{{ modalClass }}">
    <button
      *ngIf="!modalConfig.showHeader"
      type="button"
      class="btn-close position-absolute end-0 my-6 mx-6 cursor-pointer z-index-1"
      aria-label="Close"
      (click)="close()"
    ></button>

    <div *ngIf="modalConfig.modalTitle || modalTitle" class="modal-header py-5">
      <div class="d-flex align-items-center">
        <span
          *ngIf="modalConfig.modalIcon"
          class="svg-icon me-2"
          [inlineSVG]="modalConfig.modalIcon"
        ></span>
        <h4 class="modal-title text-uppercase mb-0">
          {{ modalTitle ? modalTitle : modalConfig.modalTitle }}
        </h4>
      </div>
    </div>

    <div class="modal-body">
      <ng-content></ng-content>
    </div>

    <div *ngIf="modalConfig.showFooter" class="modal-footer d-flex flex-nowrap align-items-center">
      <button
        type="button"
        class="btn btn-outline btn-outline-secondary text-primary w-100 me-lg-3"
        (click)="close()"
        *ngIf="modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()"
        [disabled]="
          modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()
        "
      >
        {{ modalConfig.closeButtonLabel }}
      </button>
      <button
        type="button"
        class="btn btn-outline btn-outline-secondary text-primary w-100 me-lg-3"
        (click)="handleDetail()"
        *ngIf="modalConfig.detailButtonLabel"
        [disabled]="
          modalConfig.disableDetailButton !== undefined && modalConfig.disableDetailButton()
        "
      >
        {{ modalConfig.detailButtonLabel }}
      </button>
      <button
        type="button"
        class="btn w-100 {{ modalConfig.color ? 'btn-' + modalConfig.color : 'btn-primary' }}"
        (click)="handleSubmit()"
        [disabled]="
          modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()
        "
      >
        <ng-container
          *ngIf="
            modalConfig.isDismissLoading !== undefined && modalConfig.isDismissLoading();
            else dismissLabel
          "
        >
          <span class="indicator-progress" [style.display]="'block'">
            Memproses...
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </ng-container>
        <ng-template #dismissLabel>{{ modalConfig.dismissButtonLabel }}</ng-template>
      </button>
    </div>
  </div>
</ng-template>
